var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTarget = function SvgTarget(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 84,
    height: 84,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#B0C9E2",
    stroke: "url(#target_svg__a)",
    strokeWidth: 1.8,
    d: "M39.65 2.396a4.7 4.7 0 0 1 4.7 0l30.773 17.767a4.7 4.7 0 0 1 2.35 4.07v35.534a4.7 4.7 0 0 1-2.35 4.07L44.35 81.603a4.7 4.7 0 0 1-4.7 0L8.877 63.838a4.7 4.7 0 0 1-2.35-4.07V24.233a4.7 4.7 0 0 1 2.35-4.07z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#004280",
    d: "M42 63.482c11.874 0 21.5-9.626 21.5-21.5s-9.626-21.5-21.5-21.5-21.5 9.626-21.5 21.5 9.626 21.5 21.5 21.5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#B0C9E2",
    fillRule: "evenodd",
    d: "M42 32.982a9 9 0 1 0 9 9c0-.943-.145-1.85-.412-2.7a1 1 0 0 1 1.908-.6c.328 1.043.504 2.152.504 3.3 0 6.075-4.925 11-11 11s-11-4.925-11-11 4.925-11 11-11c1.201 0 2.36.193 3.444.55a1 1 0 0 1-.626 1.9 9 9 0 0 0-2.818-.45",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#B0C9E2",
    fillRule: "evenodd",
    d: "M42 37.982a4 4 0 1 0 4 4 1 1 0 1 1 2 0 6 6 0 1 1-6-6 1 1 0 1 1 0 2",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#B0C9E2",
    fillRule: "evenodd",
    d: "M49.5 30.982a1 1 0 0 1 1 1v1.5H52a1 1 0 1 1 0 2h-2.086l-7.207 7.207a1 1 0 0 1-1.414-1.414l7.207-7.207v-2.086a1 1 0 0 1 1-1",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "target_svg__a",
    x1: 42,
    x2: 42,
    y1: 0,
    y2: 84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#011427"
  })))));
};
export default SvgTarget;